import React, { Component } from 'react';

import Defaults from '../../../shared/constants/defaults';
import FormSettings from '../../../shared/constants/form-settings';

import SVGIcon from '../../../../../../common/react/components/svg-icon';

import classNames from 'classnames';

import TinyMCE from 'react-tinymce';

export default class ConfirmationEmailSection extends Component {
	render() {
		let { localization } = this.props;

		// TinyMCE resolves the path to tinymce.css in a relative way, so the context
		// needs to be setup for each component using it.  Ohhhh, TinyMCE....
		const tinyMCEConfig = {
			...Defaults.TINYMCE_CONFIG,
			// XML encoding will escape output HTML string
			encodig: 'xml',
			toolbar_drawer: '',
			contextmenu: false,
			content_css: Defaults.TINYMCE_CONFIG.content_css.replace(':pathContext:', '../../../')
		};

		return (
			<section className='confirmation-email'>
				<h2>{localization.substitute('Confirmation email to respondent')}</h2>

				<div className={(this.props.formCollectsPayment || this.props.formCollectsSignature) ? "cust-disb tooltip-holder" : "tooltip-holder"}
						 data-tooltip={this.props.formCollectsPayment ? localization.substitute('Confirmation required for payments') : this.props.formCollectsSignature ? localization.substitute('Forms with signature fields require confirmation email') : null}
						 data-tooltip-position='bottom'>
						<input
								id='confirmation_toggle_checkbox'
								type='checkbox'
								value={true}
								disabled={(this.props.formCollectsPayment || this.props.formCollectsSignature)}
								checked={(this.props.formCollectsPayment || this.props.formCollectsSignature) ? true : this.props.showConfirmationEmailInput}
								onChange={this.handleToggle(FormSettings.SHOW_CONFIRMATION_EMAIL_INPUT)}
						/>
						<label htmlFor='confirmation_toggle_checkbox'>
								{localization.substitute('Allow respondent to receive confirmation email')}
						</label>

						<section className={classNames({'disabled': !this.props.showConfirmationEmailInput}, 'toggles')}>
								<div className='require-confirmation-email field'>
										<input
												id='confirmation_require_toggle_checkbox'
												type='checkbox'
												value={true}
												disabled={(this.props.formCollectsPayment || this.props.formCollectsSignature) || !this.props.showConfirmationEmailInput}
												checked={(this.props.formCollectsPayment || this.props.formCollectsSignature) ? true : (this.props.showConfirmationEmailInput && this.props.requireConfirmationEmail)}
												onChange={this.handleToggle(FormSettings.REQUIRE_CONFIRMATION_EMAIL)}
										/>
										<label htmlFor='confirmation_require_toggle_checkbox'>
												{localization.substitute('Make confirmation email address field required')}
										</label>
								</div>
								<div className='include-response field'>
										<input
												id='include_response_in_confirmation_toggle_checkbox'
												type='checkbox'
												value={true}
												checked={(this.props.formCollectsPayment || this.props.formCollectsSignature) ? true : (this.props.showConfirmationEmailInput && this.props.includeResponseInConfirmationEmail)}
												onChange={this.handleToggle(FormSettings.INCLUDE_RESPONSE_IN_CONFIRMATION)}
												disabled={(this.props.formCollectsPayment || this.props.formCollectsSignature) || !this.props.showConfirmationEmailInput}
										/>
										<label htmlFor='include_response_in_confirmation_toggle_checkbox'>
											{localization.substitute('Include form response')}
										</label>
								</div>
						</section>
				</div>

				<section className={classNames({'disabled': !this.props.showConfirmationEmailInput}, 'confirmation-message')}>
					<label>
						Confirmation email message
					</label>

					<TinyMCE
						content={this.props.confirmationEmailContent}
						config={tinyMCEConfig}
						onBlur={this.handleContentChange.bind(this, FormSettings.CONFIRMATION_EMAIL_CUSTOM_CONTENT)}
					/>
				</section>
			</section>
		);
	}

	// Custom Methods ------------------------------------------------------------
	handleContentChange = (propertyName, evt) => {
		let rteContent = evt.target.getContent();
		this.props.updateCallback(propertyName, rteContent);
	}

	handleToggle = (propertyName) => {
		return (evt) => {
			if (propertyName === FormSettings.SHOW_CONFIRMATION_EMAIL_INPUT) {
				if (!evt.target.checked) {
					this.props.updateCallback(FormSettings.REQUIRE_CONFIRMATION_EMAIL, false)
					this.props.updateCallback(FormSettings.INCLUDE_RESPONSE_IN_CONFIRMATION, false)
				}
			}

			this.props.updateCallback(propertyName, evt.target.checked)
		}
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/advanced-settings/components/sections/confirmation-email.js